<template lang="html">
<div>

    <div class="subpage">

          <div class="pgLeft">指南</div>
          <div class="pgContent">
              <textEditor ref="textEditor" :inContent="params.directoryTextContent" editorId="editor3" />
          </div>

    </div>

</div>
</template>

<script>
import { decTextGet } from "@/api/declare/declare";
export default {

    data(){
        return{
            params:{
                type:3,
                id:'',
                directoryTextContent:''
            }
        }
    },

    methods:{
        saveReturn:function(){
            this.params.directoryTextContent = this.$refs.textEditor.editorContent;
            if(this.params.directoryTextContent){
                return this.params;
            }else{
                return false;
            }
        }
    },

    mounted:function(){

            var vues = this;
            var querys = this.$route.query;

            if(querys.id){
                decTextGet({cqjSbzcDeclarationPolicyId:querys.id,type:3}).then(res => {
                    vues.params.id = res.policyReleaseContentList[0]?res.policyReleaseContentList[0].id:'';
                    vues.params.directoryTextContent = res.policyReleaseContentList[0]?res.policyReleaseContentList[0].directoryTextContent:'';
                }).finally(function(){
                    vues.$emit('inited');
                })
            }
    }
}
</script>

<style lang="scss" scoped>

.subpage{
      font-size: 15px;
     .pgLeft{
          width: 60px;
          float: left
     }
     .pgContent{
          margin-left: 60px;
          position: relative;

     }
     .cblock{

     }

}

</style>



// WEBPACK FOOTER //
// Subpage4.vue?59532bc2